import { getIdToken } from "src/domains/shared/utils/amplifyCompat";
import { backendBaseUrl } from "src/domains/shared/api/calculation/backendBaseUrl";

/**
 * 레이어 채널 — URL `/{channel}-layers/{layer_name}` 세그먼트이자 서버 `layer_type` 어휘다. projects-list 의
 * `LayerDataUiType`(LayerData 탭 박스 타입)과 같은 값이라 박스 타입을 그대로 넘긴다.
 */
export type LayerChannel = "gis" | "line" | "las" | "bim";

const HTTP_NOT_FOUND = 404;

/**
 * 레이어 1건 삭제 — `DELETE /projects/{project_id}/{channel}-layers/{layer_name}`. 서버가 행·표시 상태·원본·
 * 산출물을 일괄 정리한다(bim 은 그 이름의 확장자별 행·원본을 모두 지운다).
 *
 * main-api 는 "Bearer <token>" 형식이 필요해 Amplify `API.del` 대신 raw fetch + `getIdToken()` 으로 호출한다.
 * `layerName` 은 확장자 없는 이름 그대로다 — LayerData 행의 `origin_file_name`, 뷰어 레이어 경로의 stem, 3D 모델
 * 이름. 서버가 NFD 로 정규화하고 NFC/NFD 무관하게 찾는다.
 *
 * **404 는 성공이다** — "그 이름의 레이어가 없다"는 목표 상태가 이미 성립한 것이라 멱등 삭제로 접는다. 그 밖의
 * 실패는 `status` 를 담은 Error 로 던진다.
 */
export async function deleteLayerData(
  projectId: number,
  channel: LayerChannel,
  layerName: string
): Promise<void> {
  const token = await getIdToken();

  const res = await fetch(
    `${backendBaseUrl()}/projects/${projectId}/${channel}-layers/` +
      encodeURIComponent(layerName),
    {
      method: "DELETE",
      headers: { Authorization: token },
    }
  );

  if (res.ok || res.status === HTTP_NOT_FOUND) return;

  throw Object.assign(
    new Error(`${channel} 레이어 삭제 실패 (${res.status})`),
    { status: res.status }
  );
}
